import { createSlice } from "@reduxjs/toolkit";
import { emailVerificationBuilder } from "./builder";

const initialState = {
  data: null, // User verification data
  status: {
    loading: false,
    error: null,
  },
  sendEmail: {
    loading: false,
    error: null,
    success: false,
    message: null,
  },
  resendEmail: {
    loading: false,
    error: null,
    success: false,
    message: null,
  },
  verify: {
    loading: false,
    error: null,
    success: false,
    user: null,
  },
};

const emailVerificationSlice = createSlice({
  name: "emailVerification",
  initialState,
  reducers: {
    clearSendEmailState: (state) => {
      state.sendEmail = initialState.sendEmail;
    },
    clearResendEmailState: (state) => {
      state.resendEmail = initialState.resendEmail;
    },
    clearVerifyState: (state) => {
      state.verify = initialState.verify;
    },
    resetEmailVerificationState: () => initialState,
  },
  extraReducers: emailVerificationBuilder,
});

export const {
  clearSendEmailState,
  clearResendEmailState,
  clearVerifyState,
  resetEmailVerificationState,
} = emailVerificationSlice.actions;

// Selectors
export const selectEmailVerificationData = (state) => state.emailVerification.data;
export const selectEmailVerificationStatus = (state) => state.emailVerification.status;
export const selectSendEmailState = (state) => state.emailVerification.sendEmail;
export const selectResendEmailState = (state) => state.emailVerification.resendEmail;
export const selectVerifyEmailState = (state) => state.emailVerification.verify;

export default emailVerificationSlice.reducer;